import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import agile from "../../../images/agile.png";

const values = [
  {
    title: "Diligence ",
    description:
      "At all times, show perseverance, strong work ethics, commitment, drive, passion, sense of urgency and resourcefulness when serving our customers.",
  },
  {
    title: "Authenticity",
    description:
      "This is important to us as we honour our commitments, treat our clients fairly, speak the truth always, communicate clearly and listen attentively.",
  },
  {
    title: "Excellence ",
    description:
      "We ensure excellent service delivery to our clients and our staff function in the best manner with the least waste of time and effort.",
  },
];

const Agile = () => {
  return (
    <Box>
      <Box
        marginTop={{ xs: "2%", sm: "5%" }}
        paddingBottom={{ xs: "25%", sm: "10%" }}
      >
        <Typography
          variant="h4"
          color="#33E68C"
          fontWeight={800}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          <Typography
            component={"span"}
            color="#000"
            fontWeight={800}
            variant={"h4"}
          >
            Our Core {""}
          </Typography>
          Values
        </Typography>
        <Typography
          variant={"body1"}
          textAlign={"left"}
          color={"#000"}
          fontWeight={500}
          padding={{ xs: "5% 1%", sm: "1% 3% 3% 0%" }}
        >
          Our strengths lie in our deep understanding of the market, our
          expertise and the understanding of the needs of our clients. Our Core
          Values are;
        </Typography>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          width={"100%"}
          flexWrap={"wrap"}
        >
          {values.map((lists, id) => (
            <Box
              key={id}
              width={{ xs: "100%", sm: "32%" }}
              marginTop={{ xs: "5%", sm: "2%" }}
              data-aos={"fade-up"}
              component={Card}
              boxShadow={{ xs: 1, sm: 3 }}
              borderRadius={5}
              padding={{ xs: "5%", sm: "2%" }}
            >
              <Typography
                variant={"h6"}
                fontWeight={700}
                textAlign={"left"}
                color={"#33E68C"}
              >
                {lists.title}
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={500}
                textAlign={"left"}
                paddingTop={{ xs: "5%", sm: "3%" }}
                paddingBottom={"5%"}
                lineHeight={"1.625em"}
                color={"#000"}
              >
                {lists.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        margin={{ xs: "1% 0% 25% 0%", sm: "0% 0% 3% 0%" }}
      >
        <Box
          width={{ xs: "100%", sm: "50%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          borderRadius={"10px"}
          data-aos={"fade-down"}
        >
          <img src={agile} alt={"agile"} width={"100%"} height={"100%"} />
        </Box>
        <Box
          width={{ xs: "100%", sm: "50%" }}
          paddingLeft={{ xs: "0%", sm: "3%" }}
          paddingTop={{ xs: "5%", sm: "0%" }}
          marginBottom={"3%"}
        >
          <Typography
            variant="h4"
            color="#33E68C"
            fontWeight={800}
            paddingBottom={"3%"}
            textAlign={"left"}
          >
            <Typography
              component={"span"}
              color="#000"
              fontWeight={800}
              variant={"h4"}
            >
              Agile {""}
            </Typography>
            Culture
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={500}
            textAlign={"left"}
            color={"#000"}
            data-aos={"fade-up"}
          >
            Our teams operate on design thinking and agile principles while
            building fully functional, visually compelling web and mobile
            applications that represent your brand perfectly.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Agile;
